<template>
    <div>
        <h1 style="text-align:center">Användare</h1>
        <v-simple-table>
            <thead>
                <tr>
                    <th style="background-color:#D3D3D3;font-size:20px">
                        Förnamn
                    </th>
                    <th style="background-color:#D3D3D3;font-size:20px">
                        Efternamn
                    </th>
                    <th style="background-color:#D3D3D3;font-size:20px">
                        E-mail
                    </th>
                    <th style="background-color:#D3D3D3;font-size:20px">
                        Åtgärder
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="user in users" :key="user.id">
                    <td>{{ user.first_name }}</td>
                    <td>{{ user.last_name }}</td>
                    <td>{{ user.email }}</td>
                    <td>
                        <v-icon @click="del(user.id)">fas fa-user-minus</v-icon>
                    </td>
                </tr>
            </tbody>
        </v-simple-table>
    </div>
</template>

<script>
import axios from "axios";
import store from "../../../../store";
export default {
    data: () => ({
        users: null,
        store: store
    }),
    created: async function() {
        if (this.store.state.user.role == "user")
            this.$router.replace("/dashboard");
        if (!this.store.state.isLoggedIn) this.$router.replace("/login");
        let resp = await axios.get(`${this.store.state.baseURL}users`);
        this.users = resp.data;
    },
    methods: {
        del: async function(id) {
            try {
                await this.store.dispatch("deleteUser", id);
            } catch (err) {
                console.log(err);
            }
            window.location.reload();
        }
    }
};
</script>

<style scoped></style>
